import { AlgoliaInstantSearch } from './search-archive/algolia-instantsearch'
import { CwkSavedContent } from './favorites/favorites';
jQuery(document).ready(function($){
  //console.log('IsSearchPage', tgblCWKIsSearchPage)
  AlgoliaInstantSearch($)
  CwkSavedContent($)
});
